import React from 'react';
import './style.scss'
import { Link } from 'react-router-dom'

import Table from 'react-bootstrap/Table'

import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import MedalLink from '../../components/MedalsEbit-Link'
import Img1 from '../../assets/imagens/img-logista-small.b8bcf00f.JPG'

import Step1 from '../../assets/imagens/Passo1.6344460b.JPG'
import Step2 from '../../assets/imagens/Passo2a.233b60ec.JPG'
import Step3 from '../../assets/imagens/Passo3.d22d5fcf.JPG'
import Step4 from '../../assets/imagens/Passo4.3a93e37d.JPG'
import ImgShopper from '../../assets/imagens/img-shopper01.ad471829.jpg'

import ImgPoints1 from '../../assets/imagens/points-portal1.115181bd.JPG'
import ImgPoints2 from '../../assets/imagens/points-portal2.51a9c041.JPG'
import ImgPoints3 from '../../assets/imagens/points-portal3.829589c5.JPG'
import ImgPoints4 from '../../assets/imagens/points-portal4.6cef7604.JPG'
import ImgPoints5 from '../../assets/imagens/points-portal5.b9e65c7e.JPG'
import ImgPoints6 from '../../assets/imagens/points-portal6.8df364ad.JPG'
import ImgBinario from '../../assets/imagens/binario.JPG'
import ImgData from '../../assets/imagens/data.JPG'
import Medalha from '../../assets/imagens/medalha-diamante.png'
import Banner from '../../assets/imagens/Banner-ebit.42b357db.png'
import ImgScore from '../../assets/imagens/img-pag-score.5211a86a.jpg'

import IconUp from '../../assets/imagens/icon-graph-up.JPG'
import WebshoppersFree from '../../assets/imagens/webshoppers/Capa-WB43Free.PNG'
import WebshoppersCustom from '../../assets/imagens/webshoppers/Capa-WB43Capitulos.PNG'
import WebshoppersPremium from '../../assets/imagens/webshoppers/Capa-WB43Premium.PNG'
import Icon2 from '../../assets/imagens/icons/icon-white-red-Content-2.0ae094dd.svg'
import IconContact from '../../assets/imagens/contact-icon.55e901ba.JPG'
import IconTermo from '../../assets/imagens/termo-lojista-icon.JPG'

import LojBanner1 from '../../assets/imagens/img-banner-Lojista-ebit-02.7a382624.png'
import LojBanner2 from '../../assets/imagens/banner-loj.7005a449.jpg'



function Lojista() {
  return (
    <>
      <Menu></Menu>

      <section className="banner-premio-ebit">
        <div className="banner-premio-ebit__img-premio1">
          <img src={LojBanner1} alt="Banner Lojista" />
          <div>
            <img src={LojBanner2} alt="Segundo Banner Lojista" />
          </div>
        </div>
      </section>


      <MedalLink />
      <section className="shopper container">
        <div className="shopper__improve-medal">
          <h3>como melhoro minha medalha</h3>
          <p className="lead">
            Para que sua medalha seja melhorada, é necessário aumentar a taxa de respondentes e sua performance na visão do cliente. Existem duas maneiras para fazer essa melhoria:
          </p>
          <h5>1 - melhorias técnicas</h5>
          <ul>
            <li className="lead">Implementação do banner<strong> Light Box.</strong> <a href="https://company.ebit.com.br/developer/codigo-do-banner"> Clique aqui para detalhes.</a></li>
            <li className="lead">Implementação do banner no email de confirmação do pedido.<a href="https://company.ebit.com.br/manual-banner-por-email"> Clique aqui para detalhes.</a> </li>
            <li className="lead">Posicionamento do banner na parte superior da tela do checkout.</li>
            <li className="lead">Personalização do banner com a identidade visual do lojista.<a href="https://company.ebit.com.br/manual-personalizacao-banner"> Clique aqui para detalhes.</a></li>
          </ul>
          <h5>2 - melhorias por desempenho</h5>
          <ul>
            <li className="lead">Melhorar as taxas de entrega no prazo</li>
            <li className="lead">Melhorar o índice de probabilidade de compra do consumidor</li>
          </ul>
        </div>
        <div className="shopper__reputation-stores">
          <h3>lojas conveniadas</h3>
          <p className="lead"><a href="/reputacao-de-lojas">Clique aqui</a> para verificar todas as lojas colaboradores Ebit | Nielsen! </p>
          <img src={Img1} alt="Imagem" />
        </div>
      </section>

      <section className="portal-access container">

        <h2>
          como acesso o portal EBIT | NIELSEN?
        </h2>
        <p className="lead">Cada loja pode solicitar até 5 logins de acesso no Portal Ebit | Nielsen. O primeiro acesso é enviado ao seu email automaticamente após a aprovação da sua loja. Para acessar, basta seguir os passos abaixo:</p>


        <div className="portal-access__style">
          <div className="portal-access__style__step-access">
            <div className="portal-access__style__step-access__imgs-portal">
              <div>
                <img src={Step1} alt="Passo 1" />
              </div>
            </div>

            <p className="lead">Acessar o email de aprovação da sua loja, lá você encontrará seu login e senha do portal</p>

          </div>

          <div className="portal-access__style__step-access">
            <div className="portal-access__style__step-access__imgs-portal">
              <div>
                <img src={Step2} alt="Passo 2" />
              </div>
            </div>

            <p className="lead">Inserir esses dados no<a href="https://portal.ebit.com.br"> portal Ebit | Nielsen</a></p>

          </div>

          <div className="portal-access__style__step-access">
            <div className="portal-access__style__step-access__imgs-portal">
              <div>
                <img src={Step3} alt="Passo 3" />
              </div>
            </div>

            <p className="lead">Realizar a troca de senha temporária, para uma de sua preferência</p>

          </div>

          <div className="portal-access__style__step-access">
            <div className="portal-access__style__step-access__imgs-portal">
              <div>
                <img src={Step4} alt="Passo 4" />
              </div>
            </div>

            <p className="lead">Caso esteja aparecendo que é necessário realizar a validação de integração,<a href="https://company.ebit.com.br/developer/validar-integracao"> clique aqui!</a></p>

          </div>
        </div>

        <div className="portal-access__infos">
          <h4>Importante:</h4>
          <ul>
            <li className="lead">Utilizar a senha em 24h, caso contrário, será necessário solicitar novamente. </li>
            <li className="lead">Caso queira alterar ou incluir algum acesso, basta entrar em contato conosco através do <a href="https://ebit.zendesk.com/hc/pt-br/requests/new?ticket_form_id=65199">fale conosco.</a></li>
          </ul>
        </div>
      </section>

      <section className="content-portal container">
        <h2>o que encontro no portal EBIT | NIELSEN?</h2>

        <div className="content-portal__style">
          <div className="content-portal__style__bg-img">
            <img src={ImgShopper} alt="Foto" />
          </div>

          <div className="content-portal__style__infos">
            <div className="text-infos">
              <p className="lead">Além da credibilidade que a Ebit | Nielsen proporciona para o seu e-commerce, toda loja conveniada tem acesso a diversos relatórios gratuitos sobre o desempenho do seu e-commerce na visão dos consumidores. </p>
              <p className="lead">Os relatórios foram desenhados segundo 6 grandes temas abaixo:</p>
            </div>

            <div className="points-infos">
              <div className="points-infos__div-main">
                <img src={ImgPoints1} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints2} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints3} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints4} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints5} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints6} alt="" />
              </div>

            </div>

          </div>
        </div>

        <h5>E a liberação  deles é feita em duas etapas:</h5>

        <div className="content-portal__release-steps">
          <div className="style1">
            <img src={ImgBinario} alt="" />
            <div>
              <h6>Colaboração Simples:</h6>
              <p className="lead">liberada para lojistas que enviam no <strong>MINIMO 30%</strong> do Score</p>
            </div>
          </div>

          <div className="style1">
            <img src={ImgData} alt="" />
            <div>
              <h6>Colaboração Completa:</h6>
              <p className="lead">liberada para lojistas que enviam no <strong>MINIMO 70%</strong> do Score</p>
            </div>
          </div>
        </div>

        <div className="content-portal__table-params">

          <Table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="name-color td1">RELATÓRIOS DISPONÍVEIS</th>
                <th className="name-color">COLABORAÇÃO SIMPLES (MINIMO 30% do Score)</th>
                <th className="name-color">COLABORAÇÃO COMPLETA (MINIMO 70% do Score)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="td1">NPS</td>
                <td class="td2">Avaliação de Compra</td
                ><td class="td2">Avaliação de Entrega e Completo</td>
              </tr>
              <tr>
                <td class="td1">Indicadores de Desempenho</td>
                <td class="td2">Mensal</td>
                <td class="td2">Diário e Semanal</td>
              </tr>
              <tr>
                <td class="td1">Comentários</td>
                <td class="td2">Simplificado</td>
                <td class="td2">Completo</td>
              </tr>
              <tr>
                <td class="td1">Medalha</td>
                <td class="td2">% de Entrega no prazo e Evolução da quantidade de pesquisa</td>
                <td class="td2"> - </td>
              </tr>
              <tr>
                <td class="td1">Consumidor</td>
                <td class="td2">Perfil Demográfico</td>
                <td class="td2"> - </td>
              </tr>
              <tr>
                <td class="td1">Dados transacionais</td>
                <td class="td2">NA</td>
                <td class="td2">Top 50 produtos e Pedidos - Semanal</td>
              </tr>
            </tbody>
          </Table>


        </div>
      </section>


      <section className="score container">
        <h2>Score de Integração</h2>

        <p className="lead">O Score revela a quantificação e qualificação dos parâmetros enviados pelo lojista. </p>
        <p className="lead">Os parâmetros são os dados que a Ebit | Nielsen necessita coletar para garantir a qualidade da informação.</p>

        <h5>O cálculo do Score é determinado de acordo com os seguintes critérios:</h5>

        <div className="score__points">
          <div className="score__points__infos">
            <div className="number">
              <p><b>1</b></p>
            </div>
            <p className="text2-info lead">Correta implementação do banner</p>
          </div>

          <div className="score__points__infos">
            <div className="number">
              <p><b>2</b></p>
            </div>
            <p className="text2-info lead">Quantidade ao todo de parâmetros enviado</p>
          </div>

          <div className="score__points__infos">
            <div className="number">
              <p><b>3</b></p>
            </div>
            <p className="text2-info lead">Quantidade de envio dos parâmetros classificados como pré-requisito e obrigatórios</p>
          </div>
        </div>

        <p className="lead">Quanto mais parâmetros classificados como pré-requisito e obrigatórios, o lojista enviar, maior será o seu Score.</p>
        <p className="lead"><strong>ATENÇÃO:</strong> Ele é calculado com base na média dos últimos 8 dias e portanto é atualizado diariamente, sendo assim, diariamente o lojista está sujeito a adquirir ou perder o acesso aos relatórios gratuitos, seguindo os cortes citados acima.</p>
        <p className="lead">A parametrização é realizada em duas etapas:</p>
      </section>


      <section className="bg-score">

        <div className="score-medal">
          <div className="score-medal__number2">
            <p><b>1</b></p>
          </div>
          <div className="score-medal__text-info3">
            <p className="lead">Correta integração da <strong>Medalha</strong> Ebit | Nielsen no rodapé de todas as páginas do site da loja.</p>
          </div>
        </div>
        <div className="img01-medal">
          <img src={Medalha} alt="Medalha Ebit" />
        </div>

        <div className="score-medal">
          <div className="score-medal__number2">
            <p><b>2</b></p>
          </div>
          <div className="score-medal__text-info3">
            <p className="lead">Correta integração do <strong>Banner</strong> Ebit | Nielsen na página da loja, com a passagem dos parâmetros obrigatórios.</p>
          </div>
        </div>

        <div className="img01-banner">
          <img src={Banner} alt="Banner Ebit" />
        </div>

      </section>



      <div className="score-infos container">
        <p className="lead">Cada lojista tem um tem um script diferente, personalizado com o seu respectivo ID. Para detalhes de como realizar essa implementação <a href="https://company.ebit.com.br/developer">clique aqui.</a></p>
        
        <p className="lead">Para melhorar o seu Score siga os passos:</p>
        <div className="score-infos__steps-2">
          <div className="steps-2-infos">
            <div className="seta-red"></div>
            <p className="lead"><a href="https://company.ebit.com.br/developer/validar-integracao">Valide sua integração</a> no portal para entender o que está faltando</p>
          </div>

          <div className="steps-2-infos">
            <div className="seta-red"></div>
            <p className="lead">Garanta a aplicação de <a href="https://company.ebit.com.br/developer/codigo-do-banner">todos os parâmetros</a> requeridos e obrigatórios, no banner de sua loja</p>
          </div>

          <div className="steps-2-infos">
            <div className="seta-red"></div>
            <p className="lead">Certifique-se se seguiu todos os <a href="https://company.ebit.com.br/developer">passos de implementação</a></p>
          </div>
        </div>

        <div className="score-infos__text-img">
          <div className="text4">
            <p className="lead"><b>IMPORTANTE:</b> <strong>seu ID foi enviado no email de aprovação da sua loja</strong></p>
            <p className="lead">Quanto mais parâmetros você nos enviar:</p>
            <ul>
              <li className="lead">Maior será seu Score e <b>acesso a relatórios</b></li>
              <li className="lead"><b>Menor fica a pesquisa Ebit | Nielsen</b> para o seu consumidor. </li>
              <li className="lead">Maior será a conversão de pesquisas respondidas </li>
              <li className="lead">Maior será a <b>qualidade dos dados</b></li>
            </ul>
          </div>
          <div className="img4">
            <img src={ImgScore} alt="Imagem" />
          </div>
        </div>
      </div>

      <section className="solutions-ebit container">
        <h2>SOLUÇÕES EBIT | Nielsen</h2>
        <p className="lead">Os questionários respondidos diariamente pelos consumidores abastecem o banco de dados da Ebit | Nielsen, proporcionando <strong>relatórios únicos</strong> que traçam o perfil do consumidor e que avaliam comparativamente e com precisão os serviços prestados pelas lojas virtuais.</p>
        <p className="lead">Possibilitando à Ebit | Nielsen fornecer as seguintes soluções abaixo:</p>

        <div className="solutions-ebit__map-text">
          <h3>Mapeamento Contínuo</h3>
          <div className="style2">
            <div className="style2__contet1">
              <h6>Dados transacionais</h6>
              <ul>
                <li className="lead">Relatórios diários, semanais, mensais e trimestrais</li>
                <li className="lead">Opção de aquisições da back data ou business issue</li>
              </ul>
              <h6>Dados sazonais</h6>
              <ul>
                <li className="lead">Forecast e realizado de 9 datas sazonais</li>
              </ul>
              <h6>Dados pesquisa (compra e entrega)</h6>
              <ul>
                <li className="lead">Apresentação executiva padrão com os resultados das pesquisas e dados de consumidores</li>
              </ul>
            </div>
            <img src={IconUp} alt="Gráfico" />
          </div>
        </div>
      </section>

      <section className="webshoppers container">
        <h2>webshoppers</h2>
        <p className="lead">Estudo realizado duas vezes ao ano (Fechamento de ano e semestre) com o overview do e-commerce daquele período</p>

        <div className="webshoppers__imgs">
          <div>
            <a href="https://company.ebit.com.br/webshoppers/webshoppersfree">
            <img src={WebshoppersFree} alt="Webshoppers Free" />
            </a>
        </div>
        <div>
          <Link to="/webshoppers-capitulos">
            <img src={WebshoppersCustom} alt="Webshoppers Custom" />
          </Link>
        </div>
        <div>
          <Link to="/webshoppers-premium">
            <img src={WebshoppersPremium} alt="Webshoppers Premium" />
          </Link>
        </div>

        </div>
      </section>

          <section className="special-study container">
            <h2>Estudo Especial</h2>
            <div>
              <p className="lead">Aplicações de questionário customizado no painel de consumidores online para responder um problema de negócio específico.</p>
              <img src={Icon2} alt="Icone Arquivo" />
            </div>
          </section>

          <div className="termos">

            <div className="termo-cadastro">
              <img src={IconContact} alt="Icone contato" />
              <div>
                <h6>Termo de cadastro:</h6>
                <p className="lead">Acesse o termo de cadastro <a href="https://company.ebit.com.br/termo-cadastro">clicando aqui</a></p>
              </div>
            </div>

            <div className="termo-cadastro">
              <img src={IconTermo} alt="Icone termo" />
              <div>
                <h6>Termo de uso lojista:</h6>
                <p className="lead">Acesse o termo de uso lojista <a href="https://company.ebit.com.br/termo-lojista">clicando aqui</a></p>
              </div>
            </div>
          </div>

          <div className="business-contact container">
            <h2>Ficou alguma dúvida?</h2>
            <p className="lead"><strong>Entre em contato com nossa equipe: <a href="mailto:comercial@ebit.com.br">comercial@ebit.com.br</a></strong></p>
          </div>
          <Footer></Footer>
    </>
  );
}

export default Lojista;